import React from 'react';

const Sidebar = ({ activeTab, onTabChange }) => {
    const menuItems = [
        { id: 'games', label: 'Games Management', icon: '🎮' },
        { id: 'users', label: 'Users', icon: '👥' },
        { id: 'logs', label: 'Admin Logs', icon: '📋' }
    ];

    return (
        <div className="admin-sidebar">
            <h2 className="admin-sidebar-title">Admin Panel</h2>
            <nav className="admin-sidebar-nav">
                {menuItems.map(item => (
                    <button
                        key={item.id}
                        className={`admin-sidebar-btn ${activeTab === item.id ? 'admin-sidebar-active' : ''}`}
                        onClick={() => onTabChange(item.id)}
                    >
                        <span className="admin-sidebar-icon">{item.icon}</span>
                        <span className="admin-sidebar-label">{item.label}</span>
                    </button>
                ))}
            </nav>
        </div>
    );
};

export default Sidebar;